module.exports = __webpack_public_path__ + "img/Fussbad.46be8edb.svg";